<style lang="scss" scoped>
$leftWidth: 220px;
.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}

.el-checkbox--upload {
  position: absolute;
  left: 100px;
  top: 0;
  display: block;
}

.waring-tag {
  position: absolute;
  top: 0;
  left: 70px;
  padding-left: 10px;
  margin-bottom: 5px;
}
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>新增订单</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="120px" style="padding-right: 20px">
            <el-form-item label="货主" prop="ownerOrgId"
                          :rules="[{required: true, message: '请选择货主', trigger: 'change'}]">
              <org-select :remote-method="queryUpAllFactory" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索货主`"
                          v-model="form.ownerOrgId" :list="allOrgList" @change="setSourceOrgName"/>
            </el-form-item>
            <el-form-item label="往来单位" prop="businessOrgId"
                          :rules="[{required: true, message: '请选择往来单位', trigger: 'change'}]">
              <org-select :remote-method="queryBizOrgList" :placeholder="`请输入名称/拼音首字母缩写/系统代码搜索业务单位`"
                          v-model="form.businessOrgId" :list="bizOrgList" @change="setDirectionOrgName"/>

            </el-form-item>
            <el-form-item label="订单号" prop="orderNo" :rules="[{required: true, message: '请输入订单号', trigger: 'blur'}]">
              <oms-input placeholder="请输入订单号" type="text" v-model="form.orderNo"></oms-input>
            </el-form-item>
            <el-form-item label="业务时间" prop="operateTime"
                          :rules="[{required: true, message: '请选择业务时间', trigger: 'change'}]">
              <el-date-picker
                v-model="form.operateTime"
                type="datetime"
                placeholder="请选择业务时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="业务类型" prop="bizType"
                          :rules="[{required: true, message: '请选择业务类型', trigger: 'change'}]">
              <el-select filterable placeholder="请选择业务类型" v-model="form.bizType">
                <el-option :key="item.key" :label="item.label" :value="item.key" v-for="item in outBizTypes"/>
              </el-select>
            </el-form-item>
            <el-form-item label="追溯码" prop="codeStr" :rules="[{required: true, message: '请输入追溯码', trigger: 'blur'}]">
              <el-input v-model="form.codeStr" :rows="5" class="input-width"
                        placeholder="可以录入多个追溯码，追溯码之间可以通过逗号分隔、空格分隔、换行分隔"
                        type="textarea" @change="setCodeStr"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing">保存
              </el-button>
            </el-form-item>
            <div v-show="codeCount>0" style="padding-left: 16%">
              <span style="padding-bottom: 20px">总数：{{ codeCount }}</span>
              <span v-for="(item,index) in form.traceCodeList">
                <div style="padding-left: 40px">{{ item }}</div>
              </span>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {businessOrg, http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';

export default {
  props: ['defaultIndex'],
  mixins: [methodsMixin],
  data() {
    return {
      form: {
        ownerOrgId: '',
        ownerOrgName: '',
        businessOrgId:'',
        transactOrgId: '',
        transactOrgName: '',
        orderNo: '',
        bizType: '',
        codeStr: '',
        traceCodeList: [],
        codeBizUploadType: '0',
        operateTime: ''
      },
      bizOrgList: [],
      rules: {},
      doing: false,
      codeCount: 0
    };
  },
  computed: {
    outBizTypes: function () {
      let bizTypes = this.$getDict('bspBizType') || [];
      return bizTypes;
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
      let org = JSON.parse(window.localStorage.getItem('org'));
      let tempOrg = {
        id: org.id,
        name: org.name
      }
      this.form.ownerOrgId = org.id;
      // 设置来源单位名称
      this.form.ownerOrgName = org.name;
      this.allOrgList = [tempOrg];
      this.form.operateTime = new Date();
    }
  },
  methods: {
    setSourceOrgName: function (val) {
      if (!val) return;
      let list = this.allOrgList.filter(v => v.id === this.form.ownerOrgId);
      if (list && list[0]) {
        this.form.ownerOrgName = list[0].name;
      }
    },
    setDirectionOrgName: function (val) {
      if (!val) return;
      let list = this.bizOrgList.filter(v => v.id === val);
      if (list && list[0]) {
        this.form.transactOrgId = list[0].businessOrgId;
        this.form.transactOrgName = list[0].name;
      }
    },
    setCodeStr(val) {
      if (!val) {
        this.codeCount = 0;
        return;
      }
      let codeList = this.form.codeStr.split(/[\n,\s，]/g).filter(f => f);
      this.codeCount = codeList.length;
      this.form.traceCodeList = codeList;
    },
    queryBizOrgList(query) {
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query, deleteFlag: false, orgId: this.$store.state.user.userCompanyAddress}
      } else if (typeof query === 'object') {
        params = query;
      }
      businessOrg.query(params).then(res => {
        this.bizOrgList = res.data.list.map(m => ({
          id: m.id,
          businessOrgId: m.businessOrgId,
          name: m.businessOrgName,
          manufacturerCode: m.businessOrgManufacturerCode,
          creditCode: m.businessOrgCreditCode
        }));
      });
    },
    resetForm() {
      this.form = {
        ownerOrgId: '',
        ownerOrgName: '',
        orderNo: '',
        transactOrgId: '',
        transactOrgName: '',
        bizType: '',
        codeStr: '',
        traceCodeList: [],
        codeBizUploadType: '0',
        operateTime: ''
      };
    },
    onSubmit() {
      if (!this.form.traceCodeList.length) return this.$notify.info('请输入追溯码');
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        this.doing = true;
        http.post('/code-biz/init', form).then(res => {
          this.$emit('refresh', {id: res.data});
          this.resetForm();
          this.doing = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '保存失败'
          });
          this.doing = false;
        });
      });
    }
  }
};
</script>
